import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "rec-overlaypanel__loader"
};
const _hoisted_2 = ["innerHTML"];
import { ref } from "vue";
import { useContext } from "@/store/context";
import { storeToRefs } from "pinia";
import TranslationsApi from "@/api/translations";
// Components
import TranslationIndicator from "@/experiences/translation/components/TranslationIndicator.vue";
import OverlayPanel from "primevue/overlaypanel";
import SkeletonLoader from "@/common/components/SkeletonLoader.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TranslationStatus',
    props: {
        translationPending: { type: Boolean },
        sourceLocale: {},
        type: {},
        ids: {},
        contentKey: {}
    },
    setup(__props) {
        const props = __props;
        const context = useContext();
        const { currentStudyId: _studyId } = storeToRefs(context);
        const originalValue = ref(undefined);
        const getOriginal = () => {
            if (!originalValue.value) {
                const dto = {
                    type: props.type,
                    ids: props.ids,
                    key: props.contentKey
                };
                TranslationsApi.getTranslatedValue(dto).then((v) => {
                    originalValue.value = v;
                });
            }
        };
        const op = ref(null);
        const togglePopover = (event) => {
            if (op.value && !props.translationPending) {
                op.value.toggle(event);
            }
        };
        const onPopoverShow = () => {
            getOriginal();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(TranslationIndicator, {
                    "translation-pending": _ctx.translationPending,
                    "source-locale": _ctx.sourceLocale,
                    onClick: _withModifiers(togglePopover, ["stop"])
                }, null, 8, ["translation-pending", "source-locale"]),
                _createVNode(_unref(OverlayPanel), {
                    ref_key: "op",
                    ref: op,
                    class: "rec-overlaypanel",
                    onShow: onPopoverShow
                }, {
                    default: _withCtx(() => [
                        (!originalValue.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createVNode(SkeletonLoader, {
                                    width: "100%",
                                    height: "1rem"
                                }),
                                _createVNode(SkeletonLoader, {
                                    width: "100%",
                                    height: "1rem"
                                }),
                                _createVNode(SkeletonLoader, {
                                    width: "80%",
                                    height: "1rem"
                                })
                            ]))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                dir: "auto",
                                innerHTML: originalValue.value
                            }, null, 8, _hoisted_2))
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
